export default "__VITE_ASSET__3e9067ee__"